// extracted by mini-css-extract-plugin
export default {"cardContainer":"Achivements_cardContainer__nHkf2"};